import React, {forwardRef} from 'react';
import './style.scss';
import OrderDepartureContainer from "../../../../Redux/containers/OrderDepartureContainer";
import OrderAddress from "../OrderAddress/OrderAddress";
import OrderStatus from "../OrderStatus/OrderStatus";
import OrderScheduleNotificationContainer from "../../../../Redux/containers/OrderScheduleNotificationContainer";
import GroupedOrdersOptions from "../GroupedOrdersOptions/GroupedOrdersOptions";


const GroupedOrders = forwardRef((props, ref) => {
    const onDepartureChanged = (newDeparture) => {
        if (props.onDepartureChanged)
            props.onDepartureChanged(newDeparture);
    };

    const onScheduleNotificationClicked = (e) => {
        e.stopPropagation();
    };

    const onGroupOffClicked = (e) => {
        e.stopPropagation();

        if (props.onGroupOffClicked)
            props.onGroupOffClicked(e);
    };

    const onMouseOver = () => {
        if (props.onHover)
            props.onHover();
    };

    const onMouseLeave = () => {
        if (props.onHoverOut)
            props.onHoverOut();
    };

    const onClick = (e) => {
        if (props.onClick)
            props.onClick(e);
    };

    const onBadAddressClick = (e) => {
        e.stopPropagation();

        if (props.onBadAddressClick)
            props.onBadAddressClick(e);
    };

    return (
        <div className="order-group-container-wrapper">
            <div className="order-group-bar">
                <div className="order-group-count">
                    {props.groupCount}
                </div>
            </div>
            <div ref={ref}
                 className={'order-container' + (props.isFaded ? ' order-container-faded' : '') + (!props.allowEdit ? ' order-container-disable-edit' : '')}
                 id={props.id}>
                <div className="order-top">
                    <div className="order-right" onClick={onClick}>
                        <div className="order-metadata-container"
                             onMouseOver={onMouseOver}
                             onMouseLeave={onMouseLeave}>
                            <div className="order-address-container">
                                <OrderAddress address={props.orders[0].address}
                                              location={props.orders[0].location}
                                              onBadAddressClick={onBadAddressClick}/>
                            </div>
                            <div className="order-departure-container">
                                <OrderDepartureContainer disabled={true}
                                                         departure={props.orders[0].placeOfDeparture}
                                                         orderSource={props.orders[0].source}
                                                         isRedirected={!!props.orders[0].redirectedFromBid}
                                                         onChange={(newDeparture) => onDepartureChanged(newDeparture)}/>
                            </div>
                        </div>
                        {
                            props.isScheduleNotificationsEnabled ?
                                <>
                                    <div
                                        className="order-left-right-separator order-schedule-notification-container-right-separator"/>
                                    <div className="order-schedule-notification-container">
                                        <OrderScheduleNotificationContainer disabled={!props.allowEdit}
                                                                            onScheduleClicked={onScheduleNotificationClicked}
                                                                            order={props.orders[0]}/>
                                    </div>
                                </>
                                :
                                false
                        }
                        {
                            props.allowEdit ?
                                <>
                                    <div
                                        className="order-left-right-separator order-options-container-right-separator"/>
                                    <div className="order-options-container">
                                        <GroupedOrdersOptions disabled={!props.allowEdit}
                                                              onGroupOffClicked={onGroupOffClicked}
                                        />
                                    </div>
                                </>
                                :
                                false
                        }
                    </div>
                    <div className="order-status-container">
                        <OrderStatus readySla={props.readySla}
                                     isAutopilot={props.isAutopilot}
                                     isRedirect={props.isRedirect}
                                     orders={props.orders}/>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default GroupedOrders;